import React from 'react';
import { StatusCodes } from 'http-status-codes';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import ProductsApi from '../../../../services/api/ProductsApi';
import ProductService from '../../../../services/logic/ProductService';
import SimpleCanvas from '../../../orders/orders/SimpleCanvas';
import ButtonComponent from '../../../../components/common/forms/Button/ButtonComponent';
import DataOperationsNav from '~/src/components/common/navigation/DataOperationsNav';
import TitleComponent from '~/src/components/common/forms/Title/TitleComponent';
import SecondaryButton from '~/src/components/common/forms/Button/SecondaryButton';
import { useHistory } from 'react-router-dom';

export default function ProductPackingAnalysis(): JSX.Element {
  const [data, setData] = React.useState(null);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [visibleEmptyUsolved, setVisibleEmptyUsolved] = React.useState(false);
  const history = useHistory();
  
  const getData = async () => {
    setIsSubmitting(true);
    const res = await ProductsApi.analizePackings();

    if (res.status === StatusCodes.OK) {
      setData(res.data);
    }

    setIsSubmitting(false);
  };

  const InfoBox = ({ item }) => {
    const du = ProductService.getDu(item.packagedProducts);
    const layer = item.packagedProducts.find((x) => x.pack.type === 'Layer');
    let possible = false;

    if (item.pallet && du) {
      possible = item.pallet.width * item.pallet.length > du.width * du.length * layer.numberSmallerUnits;
    }

    const layoutData = JSON.parse(item.layout, function (prop, value) {
      var lower = prop.toLowerCase();

      if (prop === lower) {
        return value;
      } 
      else {
        this[lower] = value;
      } 
    });

    return (
      <div>
        {`${layer.numberSmallerUnits}/${item.pallet.name} : ${du ? du.width : '--'}x${du ? du.length : '--'} ${
          possible ? '' : '(NOT POSSIBLE)'
        }  - ${item.genericProduct.name}`}
        <br />
        <div>
          {item.layout && (
            <SimpleCanvas gridData={layoutData} height={item.pallet.width * 10} width={item.pallet.length * 10} />
          )}
        </div>
      </div>
    );
  };

  return (
    <WhitePad isFluid>
      <div style={{ display: 'flex' }}>
        <DataOperationsNav />
        <div>
          <TitleComponent title="Product Packing Analysis" 
          titleLeft="Back"
          onLeftHandler={(): void => history.goBack()}
          />
          <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
            <SecondaryButton isSubmitting={isSubmitting} onClick={getData} title="Run Analysis" />
          </div>
          {data && (
            <>
              <div>
                MissingPallet:
                {data.missingPallet.length}
              </div>
              <div>
                Empty GridsSolved:
                {data.emptyGridsSolved.length}
              </div>
              <div>
                <ButtonComponent
                  variant="link"
                  size="sm"
                  onClick={() => {
                    setVisibleEmptyUsolved(!visibleEmptyUsolved);
                  }}
                  title={`Empty Grids Unsolved: ${data.emptyGridsUnsolved.length}`}
                />
                <br />
                <div style={{ display: visibleEmptyUsolved ? 'block' : 'none' }}>
                  {data.emptyGridsUnsolved.map((item) => (
                    <InfoBox item={item} />
                  ))}
                </div>
              </div>
              <div>
                Missing Du Sizes:
                {data.missingDuSizes.length}
              </div>
              <div>
                Existing Grid Solved:
                {data.existingGridsSolved.length}
              </div>
              <div>
                Existing Grid Unsolved:
                {data.existingGridsUnsolved.length}
              </div>
              <div>
                Not possible due to Area:
                {data.notPossibleByArea.length}
              </div>
            </>
          )}
        </div>
      </div>
    </WhitePad>
  );
}
